import i18n from '@/locales/index'
const { t } = i18n.global
import OSS from 'ali-oss'
import { request, uploadFileOss } from "@/utils/request";
// import { GET } from "@/utils/request";
import { ElMessage, ElLoading } from "element-plus";

// new OSS({
//   // yourRegion填写Bucket所在地域。https://oss-cn-shanghai.aliyuncs.com
//   region: 'oss-cn-shanghai',
//   // 从STS服务获取的临时访问密钥（AccessKey ID和AccessKey Secret）。
//   accessKeyId: '',
//   accessKeySecret: '',
//   // endpoint: 'https://oss-cn-shanghai.aliyuncs.com',
//   // 从STS服务获取的安全令牌（SecurityToken）。
//   // stsToken: 'yourSecurityToken',
//   // refreshSTSToken: async () => {
//   // // 向您搭建的STS服务获取临时访问凭证。
//   //   const info = await fetch('your_sts_server');
//   //   return {
//   //     accessKeyId: info.accessKeyId,
//   //     accessKeySecret: info.accessKeySecret,
//   //     stsToken: info.stsToken
//   //   }
//   // },
//   // 刷新临时访问凭证的时间间隔，单位为毫秒。
//   refreshSTSTokenInterval: 300000,
//   // 填写Bucket名称。
//   bucket: 'jakabucket-shanghai'
// });

// 判断文件是否存在
async function isExistObject(client, name, options = {}) {
  try {
    await client.head(name, options)
    return true
  } catch (error) {
    if (error.code === 'NoSuchKey') {
      console.log('文件不存在')
    }
    return false
  }
}

async function ossUploadOld(name, file, {progress, path, timestamp=true}) {
  try {
    // const result = await GET('getAliOssKey')
    var loading = ElLoading.service({
      text: t('process.configtable.uploading'),
      background: 'rgba(50,50,50,.1)'
    })
    const client = new OSS({
      region: 'oss-cn-shanghai',
      accessKeyId: '',
      accessKeySecret: '',
      // stsToken: 'yourSecurityToken',
      bucket: 'jakabucket-shanghai',
      secure: true
    })
    let fileName = `${path || '/ota'}/${Date.now()}-${name}`
    if (timestamp === false) {
      fileName = `${path || '/ota'}/${name}`
    }
    // Math.random().toString().slice(-8)
    const headers = {
      // 'x-oss-forbid-overwrite': true
    }
    // object表示上传到OSS的文件名称。
    // file表示浏览器中需要上传的文件，支持HTML5 file和Blob类型。
    const r1 = await client.multipartUpload(fileName, file, {
      headers,
      progress: function (p, checkpoint) {
        // console.log(p, checkpoint)
        checkpoint
        progress && progress(p)
      },
    })
    const url = client.signatureUrl(fileName, {
      expires: 864000000 // 86400 * 10000
    })
    loading.close()
    ElMessage({
      showClose: true,
      type: "success",
      message: `${t('collect.tasklist.uploadSuccess')}!`
    })
    console.log('get success: %j', r1, url);
    return url
  } catch (error) {
    loading.close()
    ElMessage({
      showClose: true,
      type: "error",
      message: error.message || `${t('collect.tasklist.uploadFailed')}!`
    })
    console.error('error: %j', error);
    return Promise.reject()
  }
}

async function ossUpload(name, file, {progress, path, timestamp}) {
  const key = timestamp ? `${path}/${Date.now()}-${file.name}` : `${path}/${file.name}`
  const params = await request('getSTSToken', { uploadPath: key })
  console.log('getSTSToken --->', params)
  const host = `https://jakabucket-shanghai.oss-cn-shanghai.aliyuncs.com`
  const options = {
    'key': key,
    'policy': params.policy,
    'x-oss-signature-version': params.version,    //指定签名的版本和算法
    'x-oss-credential': params.x_oss_credential,   //指明派生密钥的参数集
    'x-oss-date': params.x_oss_date,   //请求的时间
    'x-oss-signature': params.signature,   //签名认证描述信息
    'x-oss-security-token': params.security_token,  //安全令牌
    'success_action_status': "200"  //上传成功后响应状态码
  }
  const formData = new FormData()
  Object.keys(options).forEach(key => {
    formData.append(key, options[key])
  })
  formData.append('file', file)
  const res = await uploadFileOss(host, formData)
  console.log('ossUpload success -->', res)
  const fileUrl = await request('getOssUrl', { filePath: key, expireTime: 86400000 * 3650 })
  console.log('ossUpload success -->', res, fileUrl)
  // return {
  //   name: file.name,
  //   fileUrl
  // }
  return fileUrl
}

async function ossUpload11(name, file, { progress, path = '/ota', timestamp = true }) {
  try {
    const key = `${path}/${Date.now()}-${file.name}`
    // 1. 获取STS凭证（确保返回正确的字段）
    const params = await request('getSTSToken', {
      uploadPath: key
    })
    
    console.log('STS参数:', params)
    
    // 2. 验证参数是否完整
    if (!params || !params.accessKeyId || !params.accessKeySecret || !params.security_token) {
      throw new Error('获取STS凭证失败，参数不完整')
    }
    
    // 3. 创建OSS客户端（使用正确的配置）
    const client = new OSS({
      region: 'oss-cn-shanghai',
      accessKeyId: params.accessKeyId,
      accessKeySecret: params.accessKeySecret,
      stsToken: params.security_token,
      bucket: 'jakabucket-shanghai',
      secure: true,
      // 重要：明确指定endpoint
      endpoint: 'oss-cn-shanghai.aliyuncs.com',
      // 如果是分片上传，可能需要配置分片大小
      timeout: 120000,
      // 内部重试
      internal: false
    })
    
    // 4. 生成文件名（处理特殊字符）
    // let fileName
    // if (timestamp === false) {
    //   fileName = `${path}/${name}`
    // } else {
    //   fileName = `${path}/${Date.now()}-${name}`
    // }
    
    // 对文件名进行URL编码（但保留路径分隔符）
    const encodedFileName = encodeURIComponent(key)
      .replace(/%2F/g, '/')  // 恢复路径分隔符
      .replace(/%20/g, ' ')  // 空格可以保留或编码
    
    console.log('上传文件名:', encodedFileName)
    
    // 5. 显示加载提示
    const loading = ElLoading.service({
      text: '上传中...',
      background: 'rgba(0, 0, 0, 0.1)'
    })
    
    // 6. 执行上传（使用put方法，更简单）
    try {
      // 方法一：使用put方法（适合中小文件）
      const result = await client.put(encodedFileName, file, {
        headers: {
          // 重要：设置正确的headers
          'Content-Type': file.type || 'application/octet-stream',
          'x-oss-object-acl': 'private',
          // 解决403问题，添加必要的STS headers
          'x-oss-security-token': params.security_token
        }
      })
      
      console.log('上传结果:', result)
      
      // 7. 生成访问URL
      // const signedUrl = client.signatureUrl(encodedFileName, {
      //   expires: 3600 * 24 * 365, // 1年有效期
      //   method: 'GET'
      // })

      const fileUrl = await request('getOssUrl', { filePath: key, expireTime: 86400000 * 3650 })
      
      // 8. 关闭加载提示
      loading.close()
      
      ElMessage.success('上传成功！')
      // {
      //   url: signedUrl,
      //   fileName: encodedFileName,
      //   etag: result.etag,
      //   size: result.size
      // }
      return fileUrl
      
    } catch (uploadError) {
      loading.close()
      console.error('上传错误详情:', uploadError)
      
      // 如果是403，提供更详细的错误信息
      if (uploadError.status === 403) {
        throw new Error(`权限被拒绝 (403)。请检查：
        1. STS Token是否有效
        2. 权限策略是否正确
        3. Bucket权限设置
        错误详情: ${uploadError.message || '未知错误'}`)
      }
      
      throw uploadError
    }
    
  } catch (error) {
    console.error('上传失败:', error)
    
    ElMessage.error({
      message: `上传失败: ${error.message || '未知错误'}`,
      duration: 5000
    })
    
    throw error
  }
}

export {
  isExistObject,
  ossUpload
}